import { render, staticRenderFns } from "./RepricingTest.vue?vue&type=template&id=66256d7f&scoped=true&"
import script from "./RepricingTest.vue?vue&type=script&lang=js&"
export * from "./RepricingTest.vue?vue&type=script&lang=js&"
import style0 from "./RepricingTest.vue?vue&type=style&index=0&id=66256d7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66256d7f",
  null
  
)

export default component.exports